import React, { Component } from 'react';
import { Header, List, Table, Icon, Button } from 'semantic-ui-react';

export default class Schedule extends Component {
  render() {
    const lectureSlideLink = "https://www.dropbox.com/sh/kqmu5ulvrahjwiu/AACUNV8f5SMbmta3wQap_B7ya?dl=0&preview="
    const discussionSlideLink = "https://www.dropbox.com/sh/q4t8sqj6ne6h69d/AAD43JwWWSZqibh05xd28PyXa?dl=0&preview="
    const scheduleRows = this.props.data.map((row) => {
      const lecSlidesLink = row["slides"] ? (
        <a href={lectureSlideLink + row["slides"]} target="_blank">Lecture</a>
      ) : null
      const disSlidesLink = row["dSlides"] ? (
        <a href={row["dSlides"].includes("http") ? row["dSlides"] : discussionSlideLink + row["dSlides"]} target="_blank">Discussion</a>
      ) : null
      const activityLink = row["activity"] ? (
        <a href={row["activity"]} target="_blank">Activity</a>
      ) : null
      const helperLinks = (lecSlidesLink || disSlidesLink || activityLink) ? (
        <Button.Group basic size='mini'>
          { lecSlidesLink ? <Button>{lecSlidesLink}</Button> : null}
          { disSlidesLink ? <Button>{disSlidesLink}</Button> : null}
          { activityLink ? <Button>{activityLink}</Button> : null}
        </Button.Group>
      ) : null


      const title = (
        (
          <div>
            <p>{ row["title"] }</p>
            { helperLinks }
          </div>
        )
      )
      const readings = row["readings"].map((reading) => {
        return reading["href"] ?
          (
            <List.Item as="a" href={ reading["href"] } target="_blank">{ reading["text"] }</List.Item>
          ) :
          (
            <List.Item as="span">{ reading["text"] }</List.Item>
          )
      })

      const commentary = row["commentary"] ? (
        <Icon color='green' name='checkmark' size='large' />
      ) : null;

      const experienceLog = row["experienceLog"] ? (
        <p>{row["experienceLog"]}</p>
      ) : null;

      const groupProject = (row["groupProject"] || []).map((asg) => {
        return (
          <List.Item as="a" href={ asg["href"] || "#" } target="_blank">{ asg["text"] }</List.Item>
        );
      })

      const virtual = row["virtual"] ? (<strong>Yes</strong>) : null;

      return (
        <Table.Row>
          <Table.Cell>{ row['date'] }</Table.Cell>
          <Table.Cell>{virtual}</Table.Cell>
          <Table.Cell>{ title }</Table.Cell>
          <Table.Cell>
            <List ordered>{ readings }</List>
          </Table.Cell>
          <Table.Cell>{ commentary }</Table.Cell>
          {/* <Table.Cell>{ experienceLog }</Table.Cell> */}
          <Table.Cell>{ groupProject }</Table.Cell>
        </Table.Row>
      );
    })

    return (
      <div>
        <Header as="h1" content="Schedule" />
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell rowSpan='2' />
              <Table.HeaderCell rowSpan='2'>Virtual?</Table.HeaderCell>
              <Table.HeaderCell rowSpan='2'>Title</Table.HeaderCell>
              <Table.HeaderCell rowSpan='2'>Readings</Table.HeaderCell>
              <Table.HeaderCell colSpan='2'>Due</Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell>Commentary</Table.HeaderCell>
              {/* <Table.HeaderCell>Experience log</Table.HeaderCell> */}
              <Table.HeaderCell>Group project</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            { scheduleRows }
          </Table.Body>
        </Table>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/schedule.js